import React from 'react';
import { SuccessFailBadge } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    content: {
        marginTop: '24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
    },
});

interface StatusBadgeGroupProps {
    status: boolean;
    trueDescription: string;
    falseDescription?: string;
    hideWhenFalse?: boolean;
    children?: React.ReactNode;
}

export function StatusBadgeGroup({
    status,
    trueDescription,
    falseDescription = '',
    hideWhenFalse = false,
    children,
}: StatusBadgeGroupProps) {
    const classes = useStyles();
    const description = status ? trueDescription : falseDescription;

    if (hideWhenFalse && !status) {
        return null;
    }

    return (
        <div>
            <div className="d-flex">
                <SuccessFailBadge iconSize="small" success={status}>
                    {description}
                </SuccessFailBadge>
            </div>
            {status && children && <div className={classes.content}>{children}</div>}
        </div>
    );
}
